// ----------------------------------------------------------------------

export default function Accordion() {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: '5px !important',
          boxShadow: 'none !important',
          backgroundColor: '#ebebeb',
          '&:before': {
            display: 'none',
          },
        },
      },
    },
  };
}
